import { createFileRoute } from '@tanstack/react-router';
import { SessionDetailPage } from '@/features/settings/AgentsPages';

export const Route = createFileRoute('/app/settings/agents/sessions/$sessionId')({
  component: function SessionRoute() {
    const { sessionId } = Route.useParams();
    return <SessionDetailPage key={sessionId} sessionId={sessionId} />;
  },
  staticData: { title: 'Agent session · Settings' },
});
